// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"294":"830d8df2b4b685a0","501":"080772430bcc802e","822":"1c185a5100b0c370","2121":"d6d5a380c196a6ff"}[chunkId] + ".js";
};